
const stringJp = {

    // Chart-page:
    label_miss_params: ' 7つの栄養素を設定してください。 ',
    label_alert_product: ' 商品がありません。 ',
    label_title_recommend: 'Online Deliveryで購入できます',
    label_dialog_chart: ' 確　定 ',
    label_title_chart: ' あなたの栄養バランス ',
    label_add_memeber: ' ＋家族構成の編集 ',
    label_add_product: ' ＋対象食品の追加 ',
    label_subTitle_chart:'各栄養素とも100%が標準です',
    label_subTitle:'※ 栄養バランスは目安になります',
    label_subTitle_right:'※ 直近30日分の購入履歴をもとに計算しています',
    label_subTitle_right2:'栄養バランスの対象食品を追加するこができます',
    
    // List family: 
    index_values: ' 1/1 ',
    label_name_member: ' ニックネーム ',
    label_birthday_member: ' 生年月日 ',
    label_gender_member: ' 性　別 ',
    label_list_dialog: ' 生年月日は一度設定すると、一定期間変更できません。 ',
    label_list_dialog_button: ' OK ',
    label_list_submit_button: ' 確　定 ',    
    delete_submit_button: ' は　い ',
    delete_cancel_button: ' いいえ ',
    delete_dialog_button: ' OK ',

    // Add-edit member: 
    label_name_info: ' ニックネームを入力して下さい ',
    label_birthday_info: ' 生年月日を入力して下さい ',
    label_birthday_info_year: ' 年 ',
    label_birthday_info_month: ' 月 ',
    label_birthday_info_day: ' 日 ',
    label_gender_info: ' 性別を選択してください ', 
    label_validate_name_min: '  ニックネームを入力して下さい ',
    label_validate_name_max: ' 20文字以内で入力してください ', 
    label_button_submit: ' 決　定 ', 
    label_button_submit_dialog: ' OK ', 
    label_button_cancel: ' キャンセル ', 

}

export default stringJp;